import { cn } from '@sparkai/utils'

import { Icon, IconsName } from '../Icon'

export type RadialIconProps = {
  variant: 'blue' | 'red' | 'gray'
  icon: IconsName
}

export function RadialIcon({ variant, icon }: RadialIconProps) {
  let outerColor, innerColor, iconColor

  switch (variant) {
    case 'blue':
      outerColor = 'bg-blue-50'
      innerColor = 'bg-blue-100'
      iconColor = 'text-blue-500'
      break
    case 'red':
      outerColor = 'bg-red-50'
      innerColor = 'bg-red-100'
      iconColor = 'text-red-500'
      break
    case 'gray':
      outerColor = 'bg-gray-100'
      innerColor = 'bg-gray-200'
      iconColor = 'text-gray-500'
      break
  }

  return (
    <div
      className={cn(
        'flex aspect-square h-[60px] w-[60px] items-center justify-center rounded-full',
        outerColor
      )}
    >
      <div
        className={cn('flex aspect-square h-10 w-10 items-center justify-center rounded-full', innerColor)}
      >
        <Icon name={icon} className={iconColor} />
      </div>
    </div>
  )
}
